export default function QuelMoteur() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <h2 className="text-2xl md:text-3xl font-bold text-brand-blue mb-6">
          Quel moteur choisir en remplacement
        </h2>
        <p className="text-brand-text leading-relaxed mb-5">
          Le choix du moteur de remplacement pour un volet Profalux dépend de plusieurs facteurs techniques. Si votre installation repose sur la technologie WireFree avec fils conducteurs dans les lames, il est recommandé de conserver un moteur compatible avec cette architecture électrique. Les moteurs Profalux d'origine sont conçus pour fonctionner avec les lames conductrices, ce qui garantit une intégration parfaite sans modification du tablier. Nous proposons aussi des moteurs alternatifs de qualité équivalente lorsque la pièce d'origine n'est plus disponible ou lorsque le client souhaite une solution économique.
        </p>
        <p className="text-brand-text leading-relaxed mb-8">
          Pour les volets équipés d'une commande radio Profalux, le remplacement doit obligatoirement inclure un moteur doté du même protocole radio ou d'un protocole compatible. Nous proposons des solutions de migration vers des systèmes radio universels (RTS, IO-Homecontrol) si le client souhaite centraliser l'ensemble des volets de la maison sous une seule commande. La puissance du moteur est calculée en fonction du poids du tablier, de sa surface et du type de lames. Nos techniciens mesurent ces paramètres sur place pour vous recommander le moteur le plus adapté, en tenant compte de la compatibilité électrique avec les lames conductrices et de la réversibilité des commandes existantes.
        </p>

        <h3 className="text-xl font-semibold text-brand-blue mb-4">
          Critères de sélection du moteur de remplacement
        </h3>
        <ul className="space-y-3">
          {[
            "Compatibilité avec les lames conductrices WireFree ou migration filaire",
            "Protocole radio Profalux compatible ou évolution vers système universel",
            "Puissance adaptée au poids du tablier et à la surface du volet",
            "Diamètre du moteur correspondant à l'axe du tablier existant",
            "Vitesse de rotation adaptée aux glissières et à l'enrouleur",
            "Garantie constructeur et disponibilité des pièces de rechange à long terme",
          ].map((item) => (
            <li key={item} className="flex items-start gap-3">
              <span className="w-5 h-5 flex items-center justify-center text-brand-cyan mt-0.5 flex-shrink-0">
                <i className="ri-checkbox-circle-line text-lg"></i>
              </span>
              <span className="text-brand-text text-sm md:text-base">{item}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}